import { Component, Inject, OnInit } from '@angular/core';
import { Game } from '../../../../../backend/src/games/entities/game.entity';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../notification/notification.service';

@Component({
  selector: 'app-edit-game',
  templateUrl: './edit-game.component.html',
  styleUrl: './edit-game.component.scss'
})
export class EditGameComponent implements OnInit {

  game: Game;
  gameForm: FormGroup;
  isSaving: boolean = false;

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<EditGameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {game: Game}
  ) {

  }

  ngOnInit() {
    this.game = this.data?.game;
    this.createGameForm();
  }

  createGameForm() {
    this.gameForm = new FormGroup({
      'id': new FormControl(this.game?.id || null),
      'name': new FormControl(this.game?.name || null, [Validators.required, Validators.minLength(2)]),
      'prefix': new FormControl(this.game?.prefix || null, [Validators.required, Validators.minLength(2)]),
      'url': new FormControl(this.game?.url || null)
    });
  }

  saveGame() {
    // Check if form is valid
    if(this.gameForm.invalid) {
      this.notificationService.show('Név és SKU előtag kötelező!', 'warning');
      return;
    }
    this.isSaving = true;
    this.http.post<Game>('games', this.gameForm.value).subscribe((game) => {
      this.notificationService.show('Játék sikeresen mentve!', 'success');
      this.dialogRef.close(true);
    }, e => {
      this.notificationService.show(`Hiba a játék mentése során! Részletek: ${e.message}`, 'danger');
      this.isSaving = false;
    });
  }


}
